export default __webpack_public_path__ + "static/media/Initiative.8c671f4f.pdf";